import CodeAutoHelpController from './code.automatique.helper.controller';

export default {
    bindings: {
        modalInstance: '<'
    },
    template: require('./code.automatique.helper.html'),
    controller: CodeAutoHelpController
};
